const calculateAge = (birthdayISO) => {
  // Parse the ISO date string to get the birthday date object
  const birthday = new Date(birthdayISO);

  // Get today's date
  const today = new Date();

  // Calculate the difference in years
  let age = today.getFullYear() - birthday.getFullYear();

  // Adjust the age if the birthday hasn't occurred yet this year
  const hasBirthdayPassed =
    today.getMonth() > birthday.getMonth() ||
    (today.getMonth() === birthday.getMonth() &&
      today.getDate() >= birthday.getDate());

  if (!hasBirthdayPassed) {
    age--;
  }

  return age;
};

export default calculateAge;
